import axios from 'axios';

// Switch between locally using the server vs the real server
let API_URL = 'https://finauta-back-staging.herokuapp.com';

if (process.env.NODE_ENV === 'development') {
  API_URL = 'http://localhost:5000';
}

const BaseApi = axios.create({
  baseURL: API_URL,
  timeout: 7500,
  headers: {
    'Content-Type': 'application/json',
  },
});

const postDebtConsolidationData = debtConsolidationData => BaseApi.post('/api/debt', debtConsolidationData);
const postRetirementData = (retirementData) =>  {
  try {
      throw `email = ${retirementData.email}`;
  } catch (error) {
    console.log(error);
  }
  return BaseApi.post('/api/retirement', retirementData)
};
const postPlan = values => BaseApi.post('/api/quote', values);
const postPhone = (phone) => {
  console.log('within postphone');
  BaseApi.post('/api/register', phone);
};
const postEmailQuote = email => BaseApi.post('/api/emailQuote', email);
const postEmailRetirement = email => BaseApi.post('/api/emailRetirement', email);
const postCurrencyData = data => BaseApi.post('/api/pesovsdollar', data);
const postBudgetData = data => BaseApi.post('/api/budget', data);
const postCallEmail = data => BaseApi.post('/api/callemail', data);
const postSendSMS = data => BaseApi.post('/api/sendsms', data);
const postVerifyCode = data => BaseApi.post('/api/verifycode', data);
const postDiagnosticData = (data) => {
  console.log(data);
  return BaseApi.post('/api/savediagnosticdata', data);
};
const postResultPlan = data => BaseApi.post('/api/createresultplan', data);
const postRetrievePlan = data => BaseApi.post('/api/retrieveplan', data);
const postRetrieveRetirement = (data) => {
  return BaseApi.post('/api/retirementplan', data);
};
const postFetchPlan = data => BaseApi.post('/api/fetchplan', data);
const postDiagnosticEmail = (data) => { console.clear(); console.log('data'); console.log(data); return BaseApi.post('/api/senddiagnosticemail', data); };
const postAvailabilityData = data => BaseApi.post('/api/schedulecall', data);

export const Api = {
  postPlan,
  postPhone,
  postEmailQuote,
  postEmailRetirement,
  postRetirementData,
  postDebtConsolidationData,
  postCurrencyData,
  postBudgetData,
  postCallEmail,
  postSendSMS,
  postVerifyCode,
  postDiagnosticData,
  postResultPlan,
  postRetrievePlan,
  postRetrieveRetirement,
  postFetchPlan,
  postDiagnosticEmail,
  postAvailabilityData,
};

export default BaseApi;
